<template>
  <FormContainer :title="$t('title.process')" :onSubmit="onSubmit" v-if="process">
    <div class="columns">
      <div :class="`column ${process.processType === 'yesno' ? 'is-9' : 'is-12'}`">
        <FormItem v-if="role.admin">
          <b-select
            expanded
            v-model="process.parentCompanyId"
            name="mainCompany"
            @input="companyChanged"
          >
            <option :value="null">{{ `--${$t('title.selectOption')}--` }}</option>
            <option v-for="option in mainCompanies" :value="option.id" :key="option.id">
              {{ option.name }}
            </option>
          </b-select>
        </FormItem>
        <FormItem v-if="role.admin">
          <b-select
            expanded
            v-model="process.processType"
            name="processType"
            v-validate="'required'"
            @input="processTypeChanged"
          >
            <option
              v-for="option in [
                { id: 'yesno', name: $t('title.yesNo') },
                { id: 'point', name: $t('title.withPoint') }
              ]"
              :value="option.id"
              :key="option.id"
            >
              {{ option.name }}
            </option>
          </b-select>
        </FormItem>
        <FormItem v-if="process.processType === 'point' && process.processGroup">
          <b-select
            expanded
            id="parentDepartmant"
            name="parentDepartmant"
            v-validate="'required'"
            v-model="process.processGroup.parentProcessGroupId"
            @input="parentProcessGroupChanged"
          >
            <option :value="null">{{ `--${$t('title.selectOption')}--` }}</option>
            <option
              v-for="option in companyParentProcessGroups"
              :value="option.id"
              :key="option.id"
            >
              {{ option.name }}
            </option>
          </b-select>
        </FormItem>
        <FormItem
          v-if="
            process.processType === 'point' &&
              process.processGroup.parentProcessGroupId &&
              selectedParentProcessGroup
          "
        >
          <b-select
            expanded
            id="childDepartmant"
            name="childDepartmant"
            v-validate="'required'"
            v-model="process.processGroupId"
          >
            <option :value="null">{{ `--${$t('title.selectOption')}--` }}</option>
            <option
              v-for="option in selectedParentProcessGroup.processGroups"
              :value="option.id"
              :key="option.id"
            >
              {{ option.name }}
            </option>
          </b-select>
        </FormItem>
        <FormItem>
          <b-input
            v-model="process.name"
            type="textarea"
            rows="2"
            v-validate="'required'"
            id="processName"
            name="name"
            expanded
          />
        </FormItem>
        <FormItem>
          <b-input
            v-model="process.description"
            type="textarea"
            rows="2"
            name="description"
            expanded
          />
        </FormItem>
        <FormItem>
          <vue-editor
            v-model="process.preliminaryText"
            :editorToolbar="editorToolbar"
            name="preliminaryText"
          ></vue-editor>
        </FormItem>
        <FormItem v-if="process.processType === 'point'">
          <b-input v-model="process.weightForPoint" v-validate="'required'" name="weightForPoint" />
        </FormItem>
        <FormItem>
          <b-input v-model="process.order" v-validate="'required'" name="order" />
        </FormItem>
      </div>
      <div class="column" v-if="process.processType === 'yesno'">
        <FormItem>
          <b-input
            v-model="process.financialReport"
            v-validate="'required'"
            name="financialReport"
            expanded
          />
        </FormItem>
        <FormItem>
          <b-input
            v-model="process.adaptation"
            v-validate="'required'"
            name="adaptation"
            expanded
          />
        </FormItem>
        <FormItem>
          <b-input v-model="process.operation" v-validate="'required'" name="operation" expanded />
        </FormItem>
        <FormItem>
          <b-input v-model="process.abuse" v-validate="'required'" name="abuse" expanded />
        </FormItem>
        <hr class="navbar-divider" />
        <div class="field" style="padding-top:10px;" v-if="role.admin">
          <b-checkbox v-model="process.isLimited" name>
            {{ $t('description.showToLimitedUsers') }}
          </b-checkbox>
        </div>
        <div class="field" style="padding-top:10px;" v-if="role.admin">
          <b-checkbox v-model="process.isSample" name>
            {{ $t('title.sampleProcess') }}
          </b-checkbox>
        </div>
      </div>
    </div>
  </FormContainer>
</template>

<script>
import { mapGetters } from 'vuex'
import { VueEditor } from 'vue2-editor'
import ApiService from '../../../_api/api.service'

export default {
  props: ['processId'],
  components: {
    VueEditor
  },
  data () {
    return {
      process: { processType: 'yesno', name: '', processGroup: {} },
      mainCompanies: [],
      companyParentProcessGroups: [],
      selectedParentProcessGroup: null,
      editorToolbar: [
        [{ size: ['small', false, 'large', 'huge'] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ color: [] }, { background: [] }],
        ['link']
      ]
    }
  },
  computed: {
    ...mapGetters(['currentUser', 'role'])
  },
  mounted () {
    if (this.role.admin) {
      this.getMainCompanies()
    }
    if (this.processId) {
      this.getProcess()
    } else if (this.role.company && this.currentUser.companyId) {
      this.process.parentCompanyId = this.currentUser.companyId
      if (this.role.processWithPoint) {
        this.process.processType = 'point'
      }
    }
    if (this.currentUser.companyId && this.role.processWithPoint) {
      this.getCompanyParentProcessGroups()
    }
  },
  methods: {
    getCompanyParentProcessGroups () {
      ApiService.query(`/select/parentcompanyprocessgroups/${this.process.parentCompanyId}`).then(
        data => {
          this.companyParentProcessGroups = data
          if (this.process && this.process.processGroup) {
            this.parentProcessGroupChanged()
          }
        }
      )
    },
    parentProcessGroupChanged () {
      this.selectedParentProcessGroup = this.companyParentProcessGroups.find(
        processGroup => processGroup.id === this.process.processGroup.parentProcessGroupId
      )
    },
    companyChanged () {
      if (this.role.admin) {
        this.process.processType = 'yesno'
      }
    },
    processTypeChanged () {
      if (this.process.processType === 'point') {
        this.getCompanyParentProcessGroups()
      }
      this.selectedParentProcessGroup = null
      this.process.processGroupId = null
      this.process.processGroup = {}
    },
    getMainCompanies () {
      ApiService.query('/select/maincompanies').then(data => {
        this.mainCompanies = data
      })
    },
    getProcess () {
      ApiService.get(`/process/${this.processId}`).then(data => {
        this.process = data
        if (this.process.processGroup) {
          this.selectedParentProcessGroup = this.companyParentProcessGroups.find(
            processGroup => processGroup.id === this.process.processGroup.parentProcessGroupId
          )
        }
      })
    },
    async onSubmit () {
      // if (parseInt(this.process.abuse) + parseInt(this.process.financialReport) + parseInt(this.process.adaptation) + parseInt(this.process.operation) !== 100) {
      //   this.$buefy.toast.open({
      //     message: 'Finansal Rapor, Uyum, Operasyon, Suistimal toplami 100 olmalıdır.',
      //     type: 'is-warning'
      //   })
      //   return
      // }
      ApiService.post('/process', { process: this.process }).then(data => {
        this.process = data
        this.$emit('saved')
        this.$parent.close()
      })
    }
  }
}
</script>
